import styled from 'styled-components';

export const Container = styled.h2`
  line-height: 1.8rem;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 5px 0 10px;
`;
